import React from 'react'

import ForthcomingEvents from './forthcoming-events'
import Header from './header'
import Actions from './actions'
import Navbar from '../../../components/nav'
import Footer from '../../../components/footer'
import {
    forFeature,
    i18n,
} from '../../../validator'

import RecuitmentsLanding from './recruitments'
import Configurator from '../../../configurator'
import { Helmet } from 'react-helmet'

@forFeature('CITIES_LANDING')
@i18n()
export default class LandingPage extends Configurator {
    constructor(props) {
        super(props)

        this.state = {
            bannerVisible: false,
            showArrow: false,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ bannerVisible: true })
        }, 1000)
        setTimeout(() => this.showArrow(), 5000)
    }

    showArrow = () => {
        this.setState({ showArrow: true })
    }

    render() {
        const {
            showNavAndFooter,
            t,
        } = this.props

        return (
            <div style={{
                display: 'flex',
                flex: '1 1 auto',
                flexDirection: 'column',
                minHeight: '100vh',
                position: 'relative',
            }}>
                {showNavAndFooter && <Navbar />}
                <Header landing={true} />
                <Actions />
                <div>
                    <h2 className="landing Forthcoming-events__title">
                        {t('landingCitiesTitle', {
                            boldText: (
                                <b className="text-uppercase">{t('actions')}</b>
                            ),
                        })}
                    </h2>
                    {!this.isChebSystem && <RecuitmentsLanding />}
                    <ForthcomingEvents />
                </div>
                {showNavAndFooter && <Footer />}
                <Helmet>
                    <link rel="alternate" href={`${this.config.REACT_APP_FRONTEND_URL}`} hrefLang="cs" />
                    <link rel="alternate" href={`${this.config.REACT_APP_FRONTEND_URL}`} hrefLang="x-default" />
                </Helmet>
            </div>
        )
    }
}
